module.exports = __webpack_public_path__ + "img/customer-a-056.61f40efb.png";